<div class="container-lg my-lg-4 main">
  <div class="py-5">
    <div class="row justify-content-center">
      <div class="text-center text-muted fs-5 pb-3" [hidden]="!loading">Verifying your email...</div>
      <div [hidden]="!loading" class="spinner-grow small text-primary" role="status">
        <span class="visually-hidden-focusable">Loading...</span>
      </div>
      <div class="text-center text-muted text-success success fs-5" [hidden]="!success" >{{ message }}</div>
      <div class="text-center text-muted error fs-5" [hidden]="!error" >{{ errorMessage }}</div>
    </div>
  </div>
</div>
